import errorManager from '@/rollbar.js';

const normalizeCF = (inputId, outputIds) => {
  const cfInput = document.getElementById(inputId);

  cfInput.addEventListener('input', function () {
    const cf = cfInput.value.toUpperCase();

    outputIds.forEach((id) => (document.getElementById(id).value = cf));
  });
};

const init = (inputSelector, outputSelectors) => {
  try {
    normalizeCF(inputSelector, outputSelectors);
  } catch (e) {
    errorManager(e);
  }
};

window.CFNormalization = {
  init,
};
